import {
  Checkbox,
  FormControlLabel,
  Grid,
  Box,
  FormHelperText,
  Skeleton,
  Paper,
} from '@mui/material'

import React, { useEffect, useState } from 'react'
import { tyreLocations } from '../../../utils/tyreLocations'
import TyreView from './TyreView'

const MultiTyreView = ({
  tyres = {},
  value = [],
  onChange,
  isField = false,
  error,
  helperText,
  loading = false,
}) => {
  if (loading) {
    return (
      <Grid container alignItems='stretch'>
        {isField && (
          <Grid item xs={12} sx={{ px: 1 }}>
            <FormHelperText error={error}>{helperText || ' '}</FormHelperText>
          </Grid>
        )}
        {tyreLocations.map(({ key }) => {
          return (
            <Grid key={key} item xs={12} sm={6} sx={{ p: 1 }}>
              <FormControlLabel
                color={error ? 'error' : undefined}
                control={
                  isField ? (
                    <>
                      <Skeleton
                        variant='rectangular'
                        sx={{ margin: '9px', width: '24px', height: '24px' }}
                      />
                      <Skeleton width='5rem' />
                    </>
                  ) : (
                    <>
                      <Box p={1} component='span'></Box>
                      <Skeleton width='5rem' />
                    </>
                  )
                }
                disabled
              />
              <Skeleton width='100%' variant='rectangular'>
                <Paper
                  sx={{
                    height: '133.017px',
                    padding: '16px',
                    width: '100%',
                  }}
                />
              </Skeleton>
            </Grid>
          )
        })}
      </Grid>
    )
  }

  const handleCheck = (el, checked) => {
    if (!checked) {
      const index = value.indexOf(el)
      if (index >= 0) {
        onChange([...value.slice(0, index), ...value.slice(index + 1)])
      }
    } else {
      onChange([...value, el])
    }
  }
  return (
    <Grid container alignItems='stretch'>
      {isField && (
        <Grid item xs={12} sx={{ px: 1 }}>
          <FormHelperText error={error}>{helperText || ' '}</FormHelperText>
        </Grid>
      )}
      {tyreLocations.map(({ key, label }) => {
        const claimed = Boolean(tyres?.[key]?.claim && tyres?.[key]?.claim?.status !== 'Rejected')
        const disabled = !tyres?.[key] || claimed
        return (
          <Grid
            key={key}
            item
            xs={12}
            sm={6}
            sx={{ p: 1, display: { xs: tyres?.[key] ? 'block' : 'none', sm: 'block' } }}
          >
            <FormControlLabel
              color={error ? 'error' : undefined}
              control={
                isField ? (
                  <Checkbox
                    onChange={(e, checked) => handleCheck(key, checked)}
                    checked={value.indexOf(key) >= 0}
                    disabled={disabled}
                  />
                ) : (
                  <Box p={1}></Box>
                )
              }
              disabled={disabled}
              label={`${label}${claimed ? ' (Claimed)' : ''}`}
            />
            <TyreView
              data={tyres?.[key]}
              id={key}
              claimed={claimed}
              clickable={isField && !disabled}
              clicked={isField && value.indexOf(key) >= 0}
              onClick={() => {
                isField && handleCheck(key, value.indexOf(key) < 0)
              }}
            />
          </Grid>
        )
      })}
    </Grid>
  )
}

export default MultiTyreView
